import connection from '@/api/connection'

// export const singIn = async ({ commit }, user) => {
//     tr
// }

export const loadOutputs = async ({ commit }, query = null) => {
    let page = 1;
    let search = '';
    let perPage = 25;
    if(query !== null){
      page = query?.page || 1;
      search = query?.search || '';
      perPage = query?.perPage || 25;
    }

    commit('setOutputIsLoading', true);
    let url = `/outputs`;
    if (search === '') {
      url = `${url}?page=${page}&perPage=${perPage}&status=cancelled`;
    } else {
      url = `${url}?search=${search}&page=${page}&perPage=${perPage}&status=cancelled`;
    }

    await connection.get(url)
      .then(res => {
        const outputs = res.data.data;
        commit('setOutputs', outputs);
        const pagination = {
            totalItems: res.data.totalItems,  // total number of elements or items
            // per_page: res.data.per_page, // items per page
            currentPage: res.data.currentPage, // current page (it will be automatically updated when users clicks on some page number).
            totalPages: res.data.totalPages, // total pages in record

            perPage: res.data.perPage 
        }
        res.data.pagination = pagination;
        commit('setOutputsPaginated', res.data);
        commit('setOutputIsLoading', false);
      }).catch(err => {
        console.log('error', err);
        commit('setOutputIsLoading', false);
      });
}